var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('keep-alive',[(_vm.istrue == true)?_c('router-view'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }